'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@src/components/Button/Button';
import type { SKUSelectionCtaProps } from '@src/components/SKUSelectionCta/SKUSelectionCta.props';
import { isSelectionStateValid, useSKUSelectionStore } from '@src/stores/SKUSelectionStore';
import { filterBuilderAttributes } from '@src/utils/builder.util';
import { cn } from '@src/utils/tailwind';
export const SKUSelectionCta = props => {
  const $ = _c(28);
  const {
    copy,
    redirectUrl,
    extraSkus,
    attributes,
    bundleId
  } = props;
  const groups = useSKUSelectionStore(_temp);
  const groupRestrictions = useSKUSelectionStore(_temp2);
  let t0;
  if ($[0] !== groupRestrictions || $[1] !== groups) {
    t0 = isSelectionStateValid(groups, groupRestrictions);
    $[0] = groupRestrictions;
    $[1] = groups;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const isValid = t0;
  let T0;
  let buttonAttributes;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[3] !== attributes || $[4] !== bundleId || $[5] !== extraSkus || $[6] !== isValid || $[7] !== redirectUrl) {
    const {
      className,
      ...t6
    } = filterBuilderAttributes(attributes);
    buttonAttributes = t6;
    T0 = Button;
    t1 = "addSelectedSKUsToCart";
    if ($[15] !== bundleId || $[16] !== extraSkus || $[17] !== redirectUrl) {
      t2 = {
        redirectUrl,
        extraSkus,
        bundleId
      };
      $[15] = bundleId;
      $[16] = extraSkus;
      $[17] = redirectUrl;
      $[18] = t2;
    } else {
      t2 = $[18];
    }
    t3 = !isValid ? "dark" : "primary";
    t4 = "medium";
    t5 = cn("mt-auto w-full lg:mt-0 lg:w-auto", className);
    $[3] = attributes;
    $[4] = bundleId;
    $[5] = extraSkus;
    $[6] = isValid;
    $[7] = redirectUrl;
    $[8] = T0;
    $[9] = buttonAttributes;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    T0 = $[8];
    buttonAttributes = $[9];
    t1 = $[10];
    t2 = $[11];
    t3 = $[12];
    t4 = $[13];
    t5 = $[14];
  }
  let t6;
  if ($[19] !== T0 || $[20] !== buttonAttributes || $[21] !== copy || $[22] !== t1 || $[23] !== t2 || $[24] !== t3 || $[25] !== t4 || $[26] !== t5) {
    t6 = <T0 actionName={t1} addSelectedSKUsToCart={t2} variant={t3} size={t4} className={t5} {...buttonAttributes}>{copy}</T0>;
    $[19] = T0;
    $[20] = buttonAttributes;
    $[21] = copy;
    $[22] = t1;
    $[23] = t2;
    $[24] = t3;
    $[25] = t4;
    $[26] = t5;
    $[27] = t6;
  } else {
    t6 = $[27];
  }
  return t6;
};
function _temp(state) {
  return state.groups;
}
function _temp2(state_0) {
  return state_0.groupRestrictions;
}